import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=9105b638&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9105b638')) {
      api.createRecord('9105b638', component.options)
    } else {
      api.reload('9105b638', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=9105b638&", function () {
      api.rerender('9105b638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/front/Home.vue"
export default component.exports